import { BrowserRouter } from 'react-router-dom';
import RouterApp from './Pages/Route/Route';
import './App.css';

function App() {
  return (
    <div >
      <BrowserRouter>
        <RouterApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
